import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["value", "onChange", "onClear", "height", "onFocus", "wrapperStyle", "inputContentStyle", "clearIconConainerStyle", "searchIconContainerStyle", "showSearchIcon"];
var _document, _document$body;
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
import React, { useEffect, useRef, useState } from 'react';
import { TextInput, View, Pressable, Platform } from 'react-native';
import CloseCircle from '../../Image/rn/CloseCircle';
import SearchIcon from '../../Image/rn/SearchIcon';
import styles from './style';
import { useTracking } from '../../../hooks/rn/useTracking';
import { gray_5 } from '../../../styles/rn';
var CLIENT_HEIGHT = Platform.OS === 'web' ? (_document = document) === null || _document === void 0 ? void 0 : (_document$body = _document.body) === null || _document$body === void 0 ? void 0 : _document$body.clientHeight : 0;
var Input = function Input(props) {
  var value = props.value,
    onChange = props.onChange,
    onClear = props.onClear,
    _props$height = props.height,
    height = _props$height === void 0 ? 24 : _props$height,
    onFocus = props.onFocus,
    wrapperStyle = props.wrapperStyle,
    inputContentStyle = props.inputContentStyle,
    clearIconConainerStyle = props.clearIconConainerStyle,
    searchIconContainerStyle = props.searchIconContainerStyle,
    _props$showSearchIcon = props.showSearchIcon,
    showSearchIcon = _props$showSearchIcon === void 0 ? false : _props$showSearchIcon,
    restProps = _objectWithoutProperties(props, _excluded);
  var _useTracking = useTracking(props),
    tracker = _useTracking.tracker,
    trackingClick = _useTracking.trackingClick;
  var _useState = useState(value),
    _useState2 = _slicedToArray(_useState, 2),
    text = _useState2[0],
    setText = _useState2[1];
  var ref = useRef(null);
  useEffect(function () {
    setText(value);
  }, [value]);
  var allowClear = true;
  var handleClear = function handleClear() {
    var _ref$current;
    setText('');
    onChange === null || onChange === void 0 ? void 0 : onChange('');
    onClear === null || onClear === void 0 ? void 0 : onClear(); // 保持键盘弹起

    ref === null || ref === void 0 ? void 0 : (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.focus();
  };
  var handleChange = function handleChange(value) {
    setText(value);
    onChange === null || onChange === void 0 ? void 0 : onChange(value);
  };
  useEffect(function () {
    if (Platform.OS === 'web' && props.inputMode === 'tel') {
      var _ref$current2;

      // for H5,手动将 type 设置为 tel
      if ((_ref$current2 = ref.current) !== null && _ref$current2 !== void 0 && _ref$current2.type) {
        ref.current.type = 'tel';
      }
    }
  }, [props.inputMode]); // @ts-ignore

  var resizeHandler = function resizeHandler(e, delay) {
    if (Platform.OS === 'web' && ref.current) {
      var key = Object.keys(ref.current).find(function (key) {
        return key.startsWith('__reactInternalInstance$');
      });
      if (key) {
        var _key;
        var dom = (_key = ref.current[key]) === null || _key === void 0 ? void 0 : _key.stateNode;
        if (!dom) {
          return;
        }
        setTimeout(function () {
          var _dom$getBoundingClien;
          var domRect = dom === null || dom === void 0 ? void 0 : (_dom$getBoundingClien = dom.getBoundingClientRect) === null || _dom$getBoundingClien === void 0 ? void 0 : _dom$getBoundingClien.call(dom);
          if ((domRect === null || domRect === void 0 ? void 0 : domRect.y) < 0) {
            var _dom$scrollIntoViewIf;

            // 先让页面可滚动
            document.getElementById('app').style.height = "".concat(CLIENT_HEIGHT, "px");
            document.body.style.overflow = 'scroll'; // 然后滚动到可视区域

            dom === null || dom === void 0 ? void 0 : (_dom$scrollIntoViewIf = dom.scrollIntoViewIfNeeded) === null || _dom$scrollIntoViewIf === void 0 ? void 0 : _dom$scrollIntoViewIf.call(dom, true);
          }
        }, delay ? delay : 100);
      }
    }
  };
  useEffect(function () {
    var _ref$current3;

    // fix: autofocus 的触发，addEventListener 监听不到 focus
    if (Platform.OS === 'web' && (_ref$current3 = ref.current) !== null && _ref$current3 !== void 0 && _ref$current3.isFocused()) {
      resizeHandler({}, 500);
    }
  }, []);
  var focusHandler = function focusHandler() {
    var _window, _window$addEventListe;
    (_window = window) === null || _window === void 0 ? void 0 : (_window$addEventListe = _window.addEventListener) === null || _window$addEventListe === void 0 ? void 0 : _window$addEventListe.call(_window, 'resize', resizeHandler);
  };
  var blurHandler = function blurHandler() {
    var _window2, _window2$removeEventL;
    if (ref.current && Platform.OS === 'web' && document.body.style.overflow === 'scroll') {
      // 恢复原有样式；
      document.getElementById('app').style.height = '100%';
      document.body.style.overflow = '';
    } // 清除监听器

    (_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$removeEventL = _window2.removeEventListener) === null || _window2$removeEventL === void 0 ? void 0 : _window2$removeEventL.call(_window2, 'resize', resizeHandler);
  };
  useEffect(function () {
    if (Platform.OS === 'web' && ref.current) {
      var key = Object.keys(ref.current).find(function (key) {
        return key.startsWith('__reactInternalInstance$');
      });
      if (key) {
        var _key2, _dom$addEventListener, _dom$addEventListener2;
        var dom = (_key2 = ref.current[key]) === null || _key2 === void 0 ? void 0 : _key2.stateNode;
        dom === null || dom === void 0 ? void 0 : (_dom$addEventListener = dom.addEventListener) === null || _dom$addEventListener === void 0 ? void 0 : _dom$addEventListener.call(dom, 'focus', focusHandler);
        dom === null || dom === void 0 ? void 0 : (_dom$addEventListener2 = dom.addEventListener) === null || _dom$addEventListener2 === void 0 ? void 0 : _dom$addEventListener2.call(dom, 'blur', blurHandler);
        return function () {
          var _dom$removeEventListe, _dom$removeEventListe2;
          dom === null || dom === void 0 ? void 0 : (_dom$removeEventListe = dom.removeEventListener) === null || _dom$removeEventListe === void 0 ? void 0 : _dom$removeEventListe.call(dom, 'focus', focusHandler);
          dom === null || dom === void 0 ? void 0 : (_dom$removeEventListe2 = dom.removeEventListener) === null || _dom$removeEventListe2 === void 0 ? void 0 : _dom$removeEventListe2.call(dom, 'blur', blurHandler);
        };
      }
    }
    return;
  }, []);
  var handleFocus = function handleFocus(e) {
    Platform.OS === 'web' && trackingClick && tracker.click(_objectSpread(_objectSpread({}, trackingClick), {}, {
      data: _objectSpread({}, (trackingClick === null || trackingClick === void 0 ? void 0 : trackingClick.data) || {})
    }));
    onFocus === null || onFocus === void 0 ? void 0 : onFocus(e);
  };
  return /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(View, {
    style: [styles.inputWrapper, !!props.errMsg ? styles.inputErrWrapper : {}, wrapperStyle]
  }, allowClear && text ? /*#__PURE__*/React.createElement(Pressable, {
    style: [styles.inputClearIconContainer, clearIconConainerStyle],
    onPress: handleClear
  }, /*#__PURE__*/React.createElement(CloseCircle, {
    style: styles.inputClearIcon
  })) : null, showSearchIcon ? /*#__PURE__*/React.createElement(View, {
    style: [styles.inputsearchIconContainerStyle, searchIconContainerStyle]
  }, /*#__PURE__*/React.createElement(SearchIcon, {
    style: styles.inputClearIcon
  })) : null, /*#__PURE__*/React.createElement(TextInput, _extends({
    style: [allowClear ? styles.inputContentWithClearIcon : styles.inputContent, {
      height: height
    }, Platform.OS === 'web' ? {
      lineHeight: 24
    } : {}, inputContentStyle],
    ref: ref,
    value: text,
    onChangeText: handleChange,
    onFocus: handleFocus
  }, restProps, {
    placeholderTextColor: gray_5,
    textAlignVertical: Platform.OS === 'android' ? 'top' : 'auto',
    autoCorrect: false,
    allowFontScaling: false
  }))));
};
export default Input;